import { KitapoService } from '../services/KitapoService';

const MODULE_PREFIX = 'bibliography';

const GETTER_FIND_REFLECTIONS_WITH_SUPPORTING_ANALYSIS = 'findReflectionsWithSupportingAnalysis';
const GETTER_FIND_REFLECTIONS_WITHOUT_SUPPORTING_ANALYSIS = 'findReflectionsWithoutSupportingAnalysis';

const MUTATION_UPDATE_REFLECTIONS = 'updateReflections';

const ACTION_FETCH_REFLECTIONS = 'fetchReflections';

const initialState = {
  reflections: [],
};

const getters = {
  // eslint-disable-next-line
  [GETTER_FIND_REFLECTIONS_WITH_SUPPORTING_ANALYSIS]: (state) => (analysisId) => state.reflections.filter(r => r.supporting_analysis_ids.includes(analysisId)),
  // eslint-disable-next-line
  [GETTER_FIND_REFLECTIONS_WITHOUT_SUPPORTING_ANALYSIS]: (state) => (analysisId) => state.reflections.filter(r => !r.supporting_analysis_ids.includes(analysisId)),
};

const mutations = {
  [MUTATION_UPDATE_REFLECTIONS]: (state, reflections) => { state.reflections = reflections; },
};

const actions = {
  [ACTION_FETCH_REFLECTIONS]: async ({ commit }) => {
    const service = new KitapoService();
    const reflections = await service.fetchAllReflections();
    commit(MUTATION_UPDATE_REFLECTIONS, reflections);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    findReflectionsWithSupportingAnalysis: `${MODULE_PREFIX}/${GETTER_FIND_REFLECTIONS_WITH_SUPPORTING_ANALYSIS}`,
    findReflectionsWithoutSupportingAnalysis: `${MODULE_PREFIX}/${GETTER_FIND_REFLECTIONS_WITHOUT_SUPPORTING_ANALYSIS}`,
  },
  mutations: {},
  actions: {
    fetchReflections: `${MODULE_PREFIX}/${ACTION_FETCH_REFLECTIONS}`,
  },
};
